// extracted by mini-css-extract-plugin
export var productImage = "_rj-1";
export var viewLink = "_rj-2";
export var wishlistItem = "_rj-0";